import React, { useState } from 'react';
import './index.scss';
import BrowsePrescriptionSubLayout from './browsePrescriptionSub';
import { withRouter } from 'react-router-dom';
import NotFound from '../../NotFound/index.jsx';

const BrowsePrescriptionsSub = props => {
  let data;
  if (
    typeof window !== 'undefined' &&
    typeof __INITIAL_DATA__ !== 'undefined'
  ) {
    data = window.__INITIAL_DATA__;
  } else {
    data = props.staticContext.data;
  }
  const [repos] = useState(data);
  const [searchTerm] = useState(
    (data && data.letter) || props.match.params.searchTerm
  );

  return (repos && repos.status >= 400) ||
    (searchTerm != '0-9' && searchTerm.length > 1) ? (
    <NotFound />
  ) : (
    <main>
      <BrowsePrescriptionSubLayout
        respData={repos && repos.allData}
        filters={repos && repos.filterTerms && repos.filterTerms.filters}
        {...props}
      />
    </main>
  );
};

export default withRouter(BrowsePrescriptionsSub);
